import React from 'react'
import { IconContext } from 'react-icons'
import IconButton from '../../forms/IconButton'
import { VscChevronLeft, VscChevronRight } from 'react-icons/vsc'
import { PaginationButton, PaginationWrapper } from './style'

type PaginationTypes = {
  totalPages: number
  setPage: Function
  activePage: number
}

const Pagination: React.FC<PaginationTypes> = ({ activePage, totalPages, setPage }) => {

  let start = Math.max(1, activePage - Math.floor(5 / 2))
  let end = start + 5 - 1

  if (end > totalPages) {
    end = totalPages
    start = Math.max(1, end - 5 + 1)
  }

  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i)

  return (
    <PaginationWrapper>
      <IconContext.Provider value={{ size: '1.3em', color: '#707070' }}>
        {activePage > 1 && (
          <IconButton
            testId="icon-left"
            onClick={() => setPage((curr: number) => curr - 1)}
            icon={<VscChevronLeft />}
          />
        )}
        {pages.map(page => (
          <PaginationButton
            role="button"
            key={page}
            active={page === activePage}
            onClick={() => setPage(page)}
          >
            {page}
          </PaginationButton>
        ))}
        {activePage < totalPages && (
          <IconButton
            testId="icon-right"
            onClick={() => setPage((curr: number) => curr + 1)}
            icon={<VscChevronRight />}
          />
        )}
      </IconContext.Provider>
    </PaginationWrapper>
  )
}

export default Pagination